module.exports = __webpack_public_path__ + "media/images/icons/plus-min-ed9a07215b8b1411e24cf40a551bf17e.svg";